import ProfileForm from "../../components/profile-form/profile-form";
import ProfileMenu from "../../components/profile-menu/profile-menu";

const ProfileInfoPage = () => {
    return (
        <>
            <ProfileMenu />
            <ProfileForm fromShow="profile" />
        </>
    );
}

export default ProfileInfoPage;